import Shop from 'static/script/app/models/shop';
import Search from 'static/script/app/models/search';
import Category from 'static/script/app/models/category';
import Suggestions from 'static/script/app/models/suggestions';
import _ from 'static/script/libs/underscore';

let SuggestionsParser = function () {
};

let p = SuggestionsParser.prototype;

p.parse = function (data) {
    let searches = this._parseSearches(data.searches);
    let shops = this._parseShops(data.shops);
    let suggestions = new Suggestions(searches, shops, data.query);

    return suggestions;
};

p._parseSearches = function (searches) {
    return _.map(searches, function (search) {
        let categories = this._parseCategories(search.categories);
        return new Search(search.text, categories);
    }.bind(this));
};

p._parseShops = function (shops) {
    return _.map(shops, function (shop) {
        return new Shop(shop.memberId, shop.name, shop.urlName);
    });
};

p._parseCategories = function (categories) {
    return _.map(categories, function (category) {
        return new Category(category.id, category.name, category.word);
    });
};

module.exports = SuggestionsParser;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/suggestions-parser.js